import React from 'react';
import './courseListCard3.module.scss';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../../../routes';
import { CourseIndexView } from '../../../../types/courses';
import { ImageApis } from '../../../../../commonv3/api/images';
import { PracticalExamCompleteRibbon, WritingExamCompleteRibbon } from '../Ribbon';
import LessonIcon from '../index/images/icon-pc.png';
import ExamIcon from '../index/images/icon-exam.png';
import TimeIcon from '../index/images/icon-time.png';
import ProgressDone from '../index/images/icon-progress-done.png';
import Progress from '../index/images/icon-progress.png';
import { CourseStatIndexView } from '../../../../types/courseStats';
import { ExamSectionStatIndexView } from '../../../../types/exam_section_stats';

type Props = {
  course: CourseIndexView;
  styleName?: string;
  className?: string;
  completeLesson: CourseStatIndexView;
  writingSectionCompleteList: ExamSectionStatIndexView[];
  practicalSectionCompleteList: ExamSectionStatIndexView[];
};

type ShowProgressProps = {
  courseLessonCount: number;
  completedLessonCount: number;
};

type ShowCourseCompleteRibbon = {
  writingSectionCompleteList: ExamSectionStatIndexView[];
  practicalSectionCompleteList: ExamSectionStatIndexView[];
  courseExamWritingCount: number;
};

const ShowProgress = ({ courseLessonCount, completedLessonCount }: ShowProgressProps) => {
  const notCompleteLessonCount = Number(courseLessonCount) - completedLessonCount;
  return (
    <span styleName="second-item">
      <span styleName="label-title">
        進捗:{completedLessonCount}/{courseLessonCount}
      </span>
      {Array(completedLessonCount)
        .fill(0)
        .map((i) => {
          return <img key={i} src={ProgressDone} styleName="icon-progress" />;
        })}
      {notCompleteLessonCount > 0 &&
        Array(notCompleteLessonCount)
          .fill(0)
          .map((i) => {
            return <img key={i} src={Progress} styleName="icon-progress" />;
          })}
    </span>
  );
};

const ShowCourseCompleteRibbon = ({
  writingSectionCompleteList,
  practicalSectionCompleteList,
  courseExamWritingCount,
}: ShowCourseCompleteRibbon) => (
  <div styleName="ribbon">
    {writingSectionCompleteList &&
      writingSectionCompleteList.length !== 0 &&
      courseExamWritingCount === writingSectionCompleteList.length && (
        <WritingExamCompleteRibbon styleName="ribbon-image" />
      )}
    {practicalSectionCompleteList && practicalSectionCompleteList.length !== 0 && (
      <PracticalExamCompleteRibbon styleName="ribbon-image" />
    )}
  </div>
);

export const CourseListCard3 = ({
  course,
  completeLesson,
  writingSectionCompleteList,
  practicalSectionCompleteList,
}: Props) => {
  return (
    <div styleName="course-list-card" id={`course-list-card-${course.id}`}>
      <Link styleName="course-image" to={V3Routes.course(course.id)}>
        <div styleName="background">
          {course.card_bg && <img styleName="eyecatch-bg" src={ImageApis.getUrlFor(course.card_bg)} />}
          {course.card_eyecatch && <img styleName="eyecatch-main" src={ImageApis.getUrlFor(course.card_eyecatch)} />}
        </div>
        <div styleName="card-main">
          <ShowCourseCompleteRibbon
            writingSectionCompleteList={writingSectionCompleteList}
            practicalSectionCompleteList={practicalSectionCompleteList}
            courseExamWritingCount={course.writing_exam_count}
          />
          <div styleName="title">{course.title}</div>
        </div>
      </Link>
      <div styleName="course-detail">
        {course.course_category !== undefined && course.course_category !== null && (
          <div styleName="course-category">{course.course_category.name}</div>
        )}
        {course.new_course && <div styleName="new-label">NEW</div>}
        <div styleName="course-detail-text">
          <img src={LessonIcon} styleName="icon" />
          <span>全{course.lesson_count}レッスン</span>{' '}
          <ShowProgress
            courseLessonCount={course.lesson_count}
            completedLessonCount={completeLesson ? completeLesson.complete_lesson_count : 0}
          />
        </div>
        {course.duration_in_minutes && (
          <div styleName="course-detail-text">
            <img src={TimeIcon} styleName="icon" />
            <span>動画時間 約{course.duration_in_minutes}分</span>
          </div>
        )}
        <div styleName="course-detail-text">
          <img src={ExamIcon} styleName="icon" />
          <span styleName="label-title">課題</span>{' '}
          {course.has_work ? <span styleName="label-active">あり</span> : <span styleName="label-inactive">なし</span>}
          <span styleName="second-item label-title">試験</span>{' '}
          {course.writing_exam_count !== 0 && <span styleName="label-active">筆記</span>}{' '}
          {course.practical_exam_count !== 0 && <span styleName="label-active">実技</span>}{' '}
          {course.practical_exam_count === 0 && course.writing_exam_count === 0 && (
            <span styleName="label-inactive">なし</span>
          )}
        </div>
      </div>
    </div>
  );
};

export const CourseListCardSpacer = () => <div styleName="course-list-card-spacer" />;
